import type { PropsWithChildren } from 'react';

import { applicationStore } from '@/store/application';

import { ApplicationContext } from './application.context';

const ApplicationProvider = ({ children }: PropsWithChildren) => {
  return <ApplicationContext.Provider value={applicationStore}>{children}</ApplicationContext.Provider>;
};

export default ApplicationProvider;
